import React from "react";

const SpanRequired = () => {
    return (
        <span className="inline-block w-[38px] h-[18px] text-[11px] ml-[8px] text-white text-center bg-[#fa5252] rounded-[20px]">
          必須
        </span>
      )
};

export default SpanRequired;